import { render, staticRenderFns } from "./mainPerson.vue?vue&type=template&id=00a47c14&scoped=true&"
import script from "./mainPerson.vue?vue&type=script&lang=js&"
export * from "./mainPerson.vue?vue&type=script&lang=js&"
import style0 from "./mainPerson.vue?vue&type=style&index=0&id=00a47c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a47c14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a47c14')) {
      api.createRecord('00a47c14', component.options)
    } else {
      api.reload('00a47c14', component.options)
    }
    module.hot.accept("./mainPerson.vue?vue&type=template&id=00a47c14&scoped=true&", function () {
      api.rerender('00a47c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/mainPerson.vue"
export default component.exports